import React, { createContext, useState, useEffect } from 'react';
import { URl } from '../utils/Common'
import { Address } from '../utils/Address'
import axios from 'axios';
import { Register } from '../utils/Api';


export const DataContext = createContext();


export const DataProvider = ({ children }) => {
  const [data, setData] = useState(null); // or [] depending on API response
  const [androidId, setAndroidId] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // alert(window.androidId);

  useEffect(() => {
    const interval = setInterval(() => {
      if (window.androidId) {
        setAndroidId(window.androidId);
        localStorage.setItem('androidId',window.androidId);
        fetchData(window.androidId);
        clearInterval(interval);
      }
    }, 500);
  }, [])

  useEffect(()=>{
    if(localStorage.getItem('androidId')){
      setAndroidId(localStorage.getItem('androidId'))
    }
  },[])

  const fetchData = async (androidId) => {
    try {
      const address = await Address()
      const response = await Register(androidId);
      // const response = await Register();
      setData(response);
      // setAndroidId()
    } catch (err) {
      setError(err);
    }
    setLoading(false);
  };

  // useEffect(() => {
  //   fetchData();
  // }, [androidId]);
  return (
    <DataContext.Provider value={{ data, loading, error, refetch: fetchData, setAndroidId, androidId }}>
      {children}
    </DataContext.Provider>
  );
};
